import React from 'react';
import { userAppData } from '../MainApp.js';
import MaintenanceSrv from './MaintenanceSingleView.js';
import MaintenanceRequests from './MaintenanceRequests.js';
import { MaintenanceForm } from './MaintenanceForm.js';
import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import './Maintenance.css';


/**
 * Redirect legacy Maintenance request URLs to the correct role-prefixed route.
 */
export function MaintenanceLegacyRequestsRedirect({ singleView = false }) {
    const location = useLocation();
    const maintenanceUser = Number(userAppData["maintenanceUser"] ?? 0);
    const routeScope = maintenanceUser >= 3 ? "admin" : "user";
    const routeSuffix = singleView ? "/requests/srv" : "/requests";

    return (
        <Navigate
            to={{
                pathname: `/app/maintenance/${routeScope}${routeSuffix}`,
                search: location.search,
            }}
            replace
        />
    );
}



export default function Maintenance() {
    let navigate = useNavigate();
    const MaintenanceUser = userAppData["MaintenanceUser"];

    if (MaintenanceUser == 0) {
        navigate("/app");
    }

    
    return (
        <div className='main_div'>
            <Outlet />
        </div>
    )
};
